import React from "react";
import jQuery from "jquery";
import $ from "jquery";
import { Link } from "react-router-dom";
export default class CreateReminders extends React.Component {
  componentDidMount() {
    this.quantity();
    this.datepicker();
  }

  quantity() {
    jQuery(
      '<div className="quantity-nav"><div className="quantity-button quantity-up">&#129053;</div><div className="quantity-button quantity-down">&#129055;</div></div>'
    ).insertAfter(".quantity input");
    jQuery(".quantity").each(function () {
      var spinner = jQuery(this),
        input = spinner.find('input[type="number"]'),
        btnUp = spinner.find(".quantity-up"),
        btnDown = spinner.find(".quantity-down"),
        min = input.attr("min"),
        max = input.attr("max");

      btnUp.click(function () {
        var oldValue = parseFloat(input.val());
        if (oldValue >= max) {
          var newVal = oldValue;
        } else {
          var newVal = oldValue + 1;
        }
        spinner.find("input").val(newVal);
        spinner.find("input").trigger("change");
      });

      btnDown.click(function () {
        var oldValue = parseFloat(input.val());
        if (oldValue <= min) {
          var newVal = oldValue;
        } else {
          var newVal = oldValue - 1;
        }
        spinner.find("input").val(newVal);
        spinner.find("input").trigger("change");
      });
    });
  }

  datepicker() {
    $(function () {
      $("#datepicker").datepicker();
      $("#todatepicker").datepicker();
    });
  }

  render() {
    return (
      <div>
        <div id="circular-menu" className="circular-menu">
          <a className="floating-btn">
            <i aria-hidden="true" className="fa fa-cog fa-spin"></i>
            <i aria-hidden="true" className="fa fa-times"></i>
          </a>

          <div className="items-wrapper">
            <div className="menu-item is-flex">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="feather feather-bell"
              >
                <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
                <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
              </svg>
            </div>
            <a
              className="menu-item is-flex right-panel-trigger"
              data-panel="languages-panel"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="feather feather-bell"
              >
                <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
                <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
              </svg>
            </a>
            <Link to="" className="menu-item is-flex">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="feather feather-bell"
              >
                <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
                <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
              </svg>
            </Link>
            <a
              className="menu-item is-flex right-panel-trigger"
              data-panel="activity-panel"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="feather feather-grid"
              >
                <rect x="3" y="3" width="7" height="7"></rect>
                <rect x="14" y="3" width="7" height="7"></rect>
                <rect x="14" y="14" width="7" height="7"></rect>
                <rect x="3" y="14" width="7" height="7"></rect>
              </svg>
            </a>
          </div>
        </div>
        <div className="container-fluid">
          <div className="create-reminder-screen">
            <div className="row g-3">
              <div className="form-head d-flex flex-wrap align-items-center">
                <div className="me-auto">
                  <h2 className="font-w600 mb-0">Create Reminders</h2>
                </div>
                <div className="rightside-tabs">
                  <div className="me-auto">
                    <Link to="Reminders">
                      <h2 className="font-w600 mb-0">Back</h2>
                    </Link>
                  </div>
                </div>
              </div>
              <div className="col-xl-9">
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-xl-8">
                        <div className="datediv">
                          <label className="text-primary mb-2 sumh04">
                            Remind me htmlFor
                          </label>
                          <div className="form-group d-flex mb-4">
                            <input
                              type="text"
                              name=""
                              className="form-control"
                              placeholder="Reminder Title goes here"
                            />
                          </div>
                          <label className="text-primary sumh04">
                            Remind Me On
                          </label>
                          <div className="form-group mb-4">
                            <div className="setdiv">
                              <div className="quantity">
                                <input
                                  type="number"
                                  min="1"
                                  max="9"
                                  step="1"
                                  value="1"
                                />
                              </div>
                              <span className="set-h">hours</span>
                            </div>
                            <div className="setdiv">
                              <div className="quantity">
                                <input
                                  type="number"
                                  min="1"
                                  max="9"
                                  step="1"
                                  value="1"
                                />
                              </div>
                              <span className="set-h">minutes</span>
                            </div>
                            <div className="setdiv">
                              <div className="quantity">
                                <input
                                  type="number"
                                  min="1"
                                  max="9"
                                  step="1"
                                  value="1"
                                />
                              </div>
                              <span className="set-h">seconds</span>
                            </div>
                            <div className="setdiv">
                              <select className="form-control">
                                <option selected>AM</option>
                                <option>PM</option>
                              </select>
                            </div>
                          </div>

                          <label className="text-primary mb-2 sumh04">
                            Also Remind
                          </label>
                          <div className="form-group d-flex mb-4">
                            <input
                              type="text"
                              name=""
                              className="form-control"
                              placeholder="@savita @geeta"
                            />
                          </div>

                          <label className="text-primary mb-2 sumh04">
                            Repeat Reminder Hourly
                          </label>
                          <div className="form-group d-flex mb-4">
                            <select className="form-control">
                              <option>None</option>
                              <option>1 Hour</option>
                              <option>2 Hour</option>
                              <option>3 Hour</option>
                            </select>
                          </div>
                        </div>
                      </div>

                      <div className="col-xl-4">
                        <label className="text-primary sumh04">
                          Schedule It
                        </label>
                        <ul
                          className="nav nav-tabs ml-auto"
                          style={{ marginLeft: "auto" }}
                        >
                          <li className="nav-item">
                            <a
                              className="nav-link active"
                              data-bs-toggle="tab"
                              href="#once"
                            >
                              Once
                            </a>
                          </li>
                          <li className="nav-item">
                            <a
                              className="nav-link"
                              data-bs-toggle="tab"
                              href="#daily"
                            >
                              Daily
                            </a>
                          </li>
                          <li className="nav-item">
                            <a
                              className="nav-link"
                              data-bs-toggle="tab"
                              href="#weekly"
                            >
                              Weekly
                            </a>
                          </li>
                          <li className="nav-item">
                            <a
                              className="nav-link"
                              data-bs-toggle="tab"
                              href="#monthly"
                            >
                              Monthly
                            </a>
                          </li>
                        </ul>
                        <div className="tab-content">
                          <div
                            className="tab-pane mt-4 p-0 active mb-4"
                            id="once"
                          >
                            <div className="form-group mb-4">
                              <label className="text-primary mb-2 sumh04">
                                Date
                              </label>
                              <input
                                type="date"
                                name=""
                                  onClick={(e) => e.target.showPicker && e.target.showPicker()}
                                className="form-control me-3"
                                placeholder="Start Date"
                                onFocus="(this.type='date')"
                              />
                            </div>
                          </div>

                          <div
                            className="tab-pane container fade mt-4 p-0 mb-4"
                            id="daily"
                          >
                            <div className="form-group mb-4">
                              <label className="text-primary mb-2 sumh04">
                                Date
                              </label>
                              <div className="d-flex">
                                <input
                                  type="date"
                                  name=""
                                    onClick={(e) => e.target.showPicker && e.target.showPicker()}
                                  className="form-control me-3"
                                  placeholder="Start Date"
                                  onFocus="(this.type='date')"
                                />
                                <span className="tocss">To</span>
                                <input
                                  type="date"
                                  name=""
                                    onClick={(e) => e.target.showPicker && e.target.showPicker()}
                                  className="form-control"
                                  placeholder="Expiry Date"
                                  onFocus="(this.type='date')"
                                />
                              </div>
                            </div>

                            <div className="form-group mb-4">
                              <label className="text-primary mb-2 sumh04">
                                Reminder will repeat after
                              </label>
                              <select className="form-control">
                                <option>10 Days</option>
                                <option>20 Days</option>
                              </select>
                            </div>
                          </div>
                          <div
                            className="tab-pane container fade mt-4 p-0 mb-4"
                            id="weekly"
                          >
                            <div className="form-group mb-4">
                              <label className="text-primary mb-2 sumh04">
                                Date
                              </label>
                              <div className="d-flex">
                                <input
                                  type="date"
                                  name=""
                                    onClick={(e) => e.target.showPicker && e.target.showPicker()}
                                  className="form-control me-3"
                                  placeholder="Start Date"
                                  onFocus="(this.type='date')"
                                />
                                <span className="tocss">To</span>
                                <input
                                  type="date"
                                  name=""
                                    onClick={(e) => e.target.showPicker && e.target.showPicker()}
                                  className="form-control"
                                  placeholder="Expiry Date"
                                  onFocus="(this.type='date')"
                                />
                              </div>
                            </div>

                            <div className="form-group mb-2">
                              <label className="text-primary mb-2 sumh04">
                                Reminder will repeat every
                              </label>
                              <select className="form-control">
                                <option>3 Week</option>
                                <option>4 Week</option>
                              </select>
                            </div>

                            <div className="form-group check-use mb-4">
                              <div className="row">
                                <div className="col-xl-4 col-xxl-6 col-6">
                                  <div className="form-check custom-checkbox mb-3">
                                    <input
                                      type="checkbox"
                                      className="form-check-input"
                                      id="customCheckBox1"
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="customCheckBox1"
                                    >
                                      Mon
                                    </label>
                                  </div>
                                </div>
                                <div className="col-xl-4 col-xxl-6 col-6">
                                  <div className="form-check custom-checkbox mb-3 checkbox-success">
                                    <input
                                      type="checkbox"
                                      className="form-check-input"
                                      id="customCheckBox2"
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="customCheckBox2"
                                    >
                                      Tue
                                    </label>
                                  </div>
                                </div>
                                <div className="col-xl-4 col-xxl-6 col-6">
                                  <div className="form-check custom-checkbox mb-3 checkbox-success">
                                    <input
                                      type="checkbox"
                                      className="form-check-input"
                                      id="customCheckBox3"
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="customCheckBox3"
                                    >
                                      Wed
                                    </label>
                                  </div>
                                </div>
                                <div className="col-xl-4 col-xxl-6 col-6">
                                  <div className="form-check custom-checkbox mb-3 checkbox-warning">
                                    <input
                                      type="checkbox"
                                      className="form-check-input"
                                      id="customCheckBox4"
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="customCheckBox4"
                                    >
                                      Thu
                                    </label>
                                  </div>
                                </div>
                                <div className="col-xl-4 col-xxl-6 col-6">
                                  <div className="form-check custom-checkbox mb-3 checkbox-danger">
                                    <input
                                      type="checkbox"
                                      className="form-check-input"
                                      id="customCheckBox5"
                                      required
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="customCheckBox5"
                                    >
                                      Fri
                                    </label>
                                  </div>
                                </div>
                                <div className="col-xl-4 col-xxl-6 col-6">
                                  <div className="form-check custom-checkbox mb-3 checkbox-danger">
                                    <input
                                      type="checkbox"
                                      className="form-check-input"
                                      id="customCheckBox6"
                                      required
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="customCheckBox6"
                                    >
                                      Sat
                                    </label>
                                  </div>
                                </div>
                                <div className="col-xl-4 col-xxl-6 col-6">
                                  <div className="form-check custom-checkbox mb-3 checkbox-danger">
                                    <input
                                      type="checkbox"
                                      className="form-check-input"
                                      id="customCheckBox7"
                                      required
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="customCheckBox7"
                                    >
                                      Sun
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div
                            className="tab-pane container fade mt-4 p-0 mb-4"
                            id="monthly"
                          >
                            <div className="form-group mb-4">
                              <label className="text-primary mb-2 sumh04">
                                Date
                              </label>
                              <div className="d-flex">
                                <input
                                  type="date"
                                  name=""
                                    onClick={(e) => e.target.showPicker && e.target.showPicker()}
                                  className="form-control me-3"
                                  placeholder="Start Date"
                                  onFocus="(this.type='date')"
                                />
                                <span className="tocss">To</span>
                                <input
                                  type="date"
                                  name=""
                                    onClick={(e) => e.target.showPicker && e.target.showPicker()}
                                  className="form-control"
                                  placeholder="Expiry Date"
                                  onFocus="(this.type='date')"
                                />
                              </div>
                            </div>

                            <div className="form-group mb-2">
                              <label className="text-primary mb-2 sumh04">
                                Months
                              </label>
                              <select className="form-control">
                                <option>Jan</option>
                                <option>Feb</option>
                              </select>
                            </div>

                            <div className="form-group check-use mb-2 d-flex">
                              <div className="form-check mr-4">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="gridRadios"
                                  value="option1"
                                  checked
                                />
                                <label className="form-check-label">Days</label>
                              </div>
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="gridRadios"
                                  value="option2"
                                  checked
                                />
                                <label className="form-check-label">On</label>
                              </div>
                            </div>

                            <div className="form-group mb-4">
                              <select className="form-control mb-4">
                                <option selected disabled>
                                  Days
                                </option>
                                <option>1</option>
                                <option>2</option>
                                <option>3</option>
                                <option>4</option>
                              </select>
                              <div className="d-flex">
                                <select className="form-control pr-4">
                                  <option selected disabled>
                                    On
                                  </option>
                                  <option>First</option>
                                  <option>Second</option>
                                </select>

                                <select className="form-control">
                                  <option>Monday, Tuesday, Weekdays</option>
                                </select>
                              </div>
                            </div>
                          </div>
                          <button className="add-btncss m-auto d-block mt-3 w-100">
                            Set Reminder
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-3">
                <div className="card bg-white">
                  <div className="reminder-sidediv p-5 pb-0">
                    <img src="images/org-img/reminders/img.png" />
                    <div></div>
                  </div>
                  <div className="col-xl-12 p-3 mt-4">
                    <div className="upcomingdiv">
                      <div className="d-flex">
                        <h4 className="text-primary sideh432 mb-4">
                          Action Pending
                        </h4>
                      </div>

                      <div className="media mb-2 event-list">
                        <div className="pr-3 text-center date-bx data1">
                          <img
                            src="images/org-img/reminders/yes-no.png"
                            className="w-100"
                          />
                        </div>
                        <div className="media-body px-0 data2">
                          <h6 className="mt-0 mb-0 fss-14">
                            <a className="text-black" href="event.html">
                              Meeting with Client
                            </a>
                          </h6>
                          <span className="mt-0 mb-3 datecol">
                            <b className="text-dark">by</b> Divya,{" "}
                            <b className="text-dark">at</b> 20-2-22
                          </span>
                        </div>
                        <div className="data3">
                          <img
                            src="images/org-img/reminders/check1.png"
                            data-toggle="tooltip"
                            data-placement="right"
                            title="Accept"
                          />
                          <img
                            src="images/org-img/reminders/close.png"
                            data-toggle="tooltip"
                            data-placement="right"
                            title="Reject"
                          />
                        </div>
                      </div>
                      <div className="media mb-2 event-list">
                        <div className="pr-3 text-center date-bx data1">
                          <img
                            src="images/org-img/reminders/yes-no.png"
                            className="w-100"
                          />
                        </div>
                        <div className="media-body px-0 data2">
                          <h6 className="mt-0 mb-0 fss-14">
                            <a className="text-black" href="event.html">
                              Meeting with Client
                            </a>
                          </h6>
                          <span className="mt-0 mb-3 datecol">
                            <b className="text-dark">by</b> Divya,{" "}
                            <b className="text-dark">at</b> 20-2-22
                          </span>
                        </div>
                        <div className="data3">
                          <img
                            src="images/org-img/reminders/check1.png"
                            data-toggle="tooltip"
                            data-placement="right"
                            title="Accept"
                          />
                          <img
                            src="images/org-img/reminders/close.png"
                            data-toggle="tooltip"
                            data-placement="right"
                            title="Reject"
                          />
                        </div>
                      </div>
                      <div className="media mb-2 event-list">
                        <div className="pr-3 text-center date-bx data1">
                          <img
                            src="images/org-img/reminders/yes-no.png"
                            className="w-100"
                          />
                        </div>
                        <div className="media-body px-0 data2">
                          <h6 className="mt-0 mb-0 fss-14">
                            <a className="text-black" href="event.html">
                              Meeting with Client
                            </a>
                          </h6>
                          <span className="mt-0 mb-3 datecol">
                            <b className="text-dark">by</b> Divya,{" "}
                            <b className="text-dark">at</b> 20-2-22
                          </span>
                        </div>
                        <div className="data3">
                          <img
                            src="images/org-img/reminders/check1.png"
                            data-toggle="tooltip"
                            data-placement="right"
                            title="Accept"
                          />
                          <img
                            src="images/org-img/reminders/close.png"
                            data-toggle="tooltip"
                            data-placement="right"
                            title="Reject"
                          />
                        </div>
                      </div>
                      <div className="media mb-2 event-list">
                        <div className="pr-3 text-center date-bx data1">
                          <img
                            src="images/org-img/reminders/yes-no.png"
                            className="w-100"
                          />
                        </div>
                        <div className="media-body px-0 data2">
                          <h6 className="mt-0 mb-0 fss-14">
                            <a className="text-black" href="event.html">
                              Meeting with Client
                            </a>
                          </h6>
                          <span className="mt-0 mb-3 datecol">
                            <b className="text-dark">by</b> Divya,{" "}
                            <b className="text-dark">at</b> 20-2-22
                          </span>
                        </div>
                        <div className="data3">
                          <img
                            src="images/org-img/reminders/check1.png"
                            data-toggle="tooltip"
                            data-placement="right"
                            title="Accept"
                          />
                          <img
                            src="images/org-img/reminders/close.png"
                            data-toggle="tooltip"
                            data-placement="right"
                            title="Reject"
                          />
                        </div>
                      </div>

                      <div className="card-body pb-0"></div>
                    </div>
                  </div>
                </div>
                <div className="card bg-white">
                  <div className="col-xl-12 p-3">
                    <div className="upcomingdiv">
                      <div className="d-flex">
                        <h4 className="text-primary sideh432 mb-4">Upcoming</h4>
                      </div>
                      <div className="media mb-2 event-list">
                        <div className="pr-3 text-center date-bx data1">
                          <img
                            src="images/org-img/reminders/icon0.png"
                            className="w-100"
                          />
                        </div>
                        <div className="media-body px-0 data2">
                          <h6 className="mt-0 mb-0 fss-14">
                            <a className="text-black" href="event.html">
                              Meeting with Client
                            </a>
                          </h6>
                          <span className="mt-0 mb-3 datecol">
                            <b className="text-dark">by</b> Divya,{" "}
                            <b className="text-dark">at</b> 20-2-22
                          </span>
                        </div>
                        <div className="rem-circle02">
                          <label className="switch">
                            <input type="checkbox" />
                            <span className="slider round"></span>
                          </label>
                        </div>
                      </div>
                      <div className="media mb-2 event-list">
                        <div className="pr-3 text-center date-bx data1">
                          <img
                            src="images/org-img/reminders/icon0.png"
                            className="w-100"
                          />
                        </div>
                        <div className="media-body px-0 data2">
                          <h6 className="mt-0 mb-0 fss-14">
                            <a className="text-black" href="event.html">
                              Meeting with Client
                            </a>
                          </h6>
                          <span className="mt-0 mb-3 datecol">
                            <b className="text-dark">by</b> Divya,{" "}
                            <b className="text-dark">at</b> 20-2-22
                          </span>
                        </div>
                        <div className="rem-circle02">
                          <label className="switch">
                            <input type="checkbox" />
                            <span className="slider round"></span>
                          </label>
                        </div>
                      </div>
                      <div className="media mb-2 event-list">
                        <div className="pr-3 text-center date-bx data1">
                          <img
                            src="images/org-img/reminders/icon0.png"
                            className="w-100"
                          />
                        </div>
                        <div className="media-body px-0 data2">
                          <h6 className="mt-0 mb-0 fss-14">
                            <a className="text-black" href="event.html">
                              Meeting with Client
                            </a>
                          </h6>
                          <span className="mt-0 mb-3 datecol">
                            <b className="text-dark">by</b> Divya,{" "}
                            <b className="text-dark">at</b> 20-2-22
                          </span>
                        </div>
                        <div className="rem-circle02">
                          <label className="switch">
                            <input type="checkbox" />
                            <span className="slider round"></span>
                          </label>
                        </div>
                      </div>
                      <div className="media mb-2 event-list">
                        <div className="pr-3 text-center date-bx data1">
                          <img
                            src="images/org-img/reminders/icon0.png"
                            className="w-100"
                          />
                        </div>
                        <div className="media-body px-0 data2">
                          <h6 className="mt-0 mb-0 fss-14">
                            <a className="text-black" href="event.html">
                              Meeting with Client
                            </a>
                          </h6>
                          <span className="mt-0 mb-3 datecol">
                            <b className="text-dark">by</b> Divya,{" "}
                            <b className="text-dark">at</b> 20-2-22
                          </span>
                        </div>
                        <div className="rem-circle02">
                          <label className="switch">
                            <input type="checkbox" />
                            <span className="slider round"></span>
                          </label>
                        </div>
                      </div>
                      <div className="card-body pb-0"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="modal fade" id="contact-manager">
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title m-auto">
                    Contact Your Reporting Manager htmlFor Any Leave
                    Clarifications
                  </h5>
                </div>
                <div className="modal-body text-center">
                  <form>
                    <div className="form-group text-left">
                      <label>Repoting Manager</label>
                      <select className="default-select form-control wide mb-3">
                        <option selected disabled>
                          Select reporting manager
                        </option>
                        <option>Arun Mishra</option>
                        <option>Pragya Tiwari</option>
                        <option>Alisha Goyal</option>
                      </select>
                    </div>
                    <div className="form-group text-left">
                      <label className="mt-3">Reason</label>
                      <textarea
                        rows="4"
                        cols="1"
                        className="form-control"
                      ></textarea>
                    </div>
                  </form>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-danger light"
                    data-bs-dismiss="modal"
                  >
                    Decline
                  </button>
                  <button type="button" className="btn btn-primary">
                    Accept
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
